import {
  HomeIcon,
  InformationCircleIcon,
  StarIcon,
  BuildingOfficeIcon,
  PhotoIcon,
  QuestionMarkCircleIcon,
  RectangleStackIcon,
  MapPinIcon,
  PhoneIcon,
  BoltIcon,
  MapIcon,
  AcademicCapIcon,
  BookOpenIcon,
  ShieldCheckIcon,
  FaceSmileIcon,
  VideoCameraIcon,
  SunIcon,
  CheckBadgeIcon,
  PuzzlePieceIcon,
  GlobeAltIcon,
  HeartIcon,
  CogIcon,
  WrenchIcon,
  TruckIcon,
  WifiIcon,
  SparklesIcon,
  FireIcon,
  LightBulbIcon,
  CloudIcon,
  KeyIcon,
  LockClosedIcon,
  ShoppingCartIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  ClockIcon,
  CalendarIcon,
  UserGroupIcon,
  UsersIcon,
  UserIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  BellIcon,
  CameraIcon,
  MusicalNoteIcon,
  FilmIcon,
  DocumentTextIcon,
  FolderIcon,
  ArrowTrendingUpIcon,
  HandThumbUpIcon,
  TrophyIcon,
  FlagIcon,
  TagIcon,
  SignalIcon,
  ComputerDesktopIcon,
  DevicePhoneMobileIcon,
  ServerIcon,
  CircleStackIcon,
  CommandLineIcon,
  PaintBrushIcon,
  SwatchIcon,
  ScissorsIcon,
  MagnifyingGlassIcon,
  AdjustmentsHorizontalIcon,
  Cog6ToothIcon,
  WrenchScrewdriverIcon,
  BeakerIcon,
  RocketLaunchIcon,
  PaperAirplaneIcon,
  ArchiveBoxIcon,
  BriefcaseIcon,
  BuildingLibraryIcon,
  BuildingStorefrontIcon,
  CubeIcon,
  GiftIcon,
  HomeModernIcon,
  LifebuoyIcon,
  MegaphoneIcon,
  NewspaperIcon,
  PresentationChartLineIcon,
  ShieldExclamationIcon,
  SquaresPlusIcon,
  TicketIcon,
  WindowIcon,
} from '@heroicons/react/24/outline';

// Map of icon name strings to their actual React components
const iconMap: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  HomeIcon,
  InformationCircleIcon,
  StarIcon,
  BuildingOfficeIcon,
  PhotoIcon,
  QuestionMarkCircleIcon,
  RectangleStackIcon,
  MapPinIcon,
  PhoneIcon,
  BoltIcon,
  MapIcon,
  AcademicCapIcon,
  BookOpenIcon,
  ShieldCheckIcon,
  FaceSmileIcon,
  VideoCameraIcon,
  SunIcon,
  CheckBadgeIcon,
  PuzzlePieceIcon,
  GlobeAltIcon,
  HeartIcon,
  CogIcon,
  WrenchIcon,
  TruckIcon,
  WifiIcon,
  SparklesIcon,
  FireIcon,
  LightBulbIcon,
  CloudIcon,
  KeyIcon,
  LockClosedIcon,
  ShoppingCartIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  ClockIcon,
  CalendarIcon,
  UserGroupIcon,
  UsersIcon,
  UserIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  BellIcon,
  CameraIcon,
  MusicalNoteIcon,
  FilmIcon,
  DocumentTextIcon,
  FolderIcon,
  ArrowTrendingUpIcon,
  HandThumbUpIcon,
  TrophyIcon,
  FlagIcon,
  TagIcon,
  SignalIcon,
  ComputerDesktopIcon,
  DevicePhoneMobileIcon,
  ServerIcon,
  CircleStackIcon,
  CommandLineIcon,
  PaintBrushIcon,
  SwatchIcon,
  ScissorsIcon,
  MagnifyingGlassIcon,
  AdjustmentsHorizontalIcon,
  Cog6ToothIcon,
  WrenchScrewdriverIcon,
  BeakerIcon,
  RocketLaunchIcon,
  PaperAirplaneIcon,
  ArchiveBoxIcon,
  BriefcaseIcon,
  BuildingLibraryIcon,
  BuildingStorefrontIcon,
  CubeIcon,
  GiftIcon,
  HomeModernIcon,
  LifebuoyIcon,
  MegaphoneIcon,
  NewspaperIcon,
  PresentationChartLineIcon,
  ShieldExclamationIcon,
  SquaresPlusIcon,
  TicketIcon,
  WindowIcon,
};

/**
 * Resolves an icon name string (e.g., "HomeIcon") to its HeroIcon component.
 * Returns StarIcon as a fallback if the icon name is not found.
 */
export const getIconComponent = (iconName?: string): React.ComponentType<React.SVGProps<SVGSVGElement>> => {
  if (!iconName) return StarIcon;
  return iconMap[iconName] || StarIcon;
};

export default iconMap;
